import { FormBase } from 'core/components';

export default class DimensionsStepForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.state.options.set({
			showErrorsOnReset: true,
		});
	}
	setup() {
		return {
			fields: [
				{
					name: 'boxId',
					label: 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.BOXDIMENSIONS',
					rules: 'required',
				},
				{
					name: 'name',
					label: 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.NAME',
					rules: 'required',
				},
				{
					name: 'height',
					label: 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.HEIGHT',
					rules: 'required|integer',
				},
				{
					name: 'width',
					label: 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.WIDTH',
					rules: 'required|integer',
				},
				{
					name: 'length',
					label: 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.LENGTH',
					rules: 'required|integer',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/labeling-mode/DimensionsStepForm.js